export class ChannelFreqObject {
  channel: string = null;
  vorFreq: number = null;
  uplinkFreq: number = null;
  downlinkFreq: number = null;
  type : string = null;

  constructor(channel : string, vorFreq : number, uplinkFreq : number,
    downlinkFreq : number, type : string) {
  this.channel = channel;
  this.vorFreq = vorFreq;
  this.uplinkFreq = uplinkFreq;
  this.downlinkFreq = downlinkFreq;
  this.type = type;
  }
}
